import React from 'react';
import { Icon } from '@iconify/react';

import accountArrowDown from '@iconify/icons-mdi/account-arrow-down';
import bullseyeArrow from '@iconify/icons-mdi/bullseye-arrow';
import webBox from '@iconify/icons-mdi/web-box';

const siteConfig = require(`~/data/site/site.${process.env.GATSBY_SITE}.json`);

const ItemMeta = ({ item, className }) => {
	const audiencesLabel = siteConfig.filters.find(
		filter => filter.id === 'audiences'
	).displayName;
	const endusersLabel = siteConfig.filters.find(
		filter => filter.id === 'end_users'
	).displayName;

	return (
		<div className={`pl-5 ${className ?? ''}`}>
			{item.Availability && (
				<div className="text-card-product-audience">
					<p className="inline-block mr-1 font-bold">
						<Icon
							icon={webBox}
							height="1rem"
							width="1rem"
							className="inline mr-1 mb-0.5 -ml-5"
						/>
						Language
						{item.Availability.length > 1 ||
						item.Availability[0].data.Availability.indexOf('/') >= 0
							? 's'
							: ''}
						:
					</p>
					<ul className="inline">
						{[
							...new Set(
								item.Availability.map(
									availability => availability.data.Language[0].data.Name
								)
							)
						].map((languageName, index, uniqueLanguages) => (
							<li
								key={languageName}
								className={`
									inline
									${uniqueLanguages.length > 1 && 'after:content-[",_"] last:after:content-[""]'}
								`}
							>
								{languageName}
							</li>
						))}
					</ul>
				</div>
			)}
			{item.Audiences && (
				<div className="text-card-product-audience mt-1.5">
					<p className="inline-block mr-1 font-bold">
						<Icon
							icon={accountArrowDown}
							height="1rem"
							width="1rem"
							className="inline mr-1 mb-0.5 -ml-5"
						/>
						{audiencesLabel}
						{!audiencesLabel.endsWith('s') && audiencesLabel.length > 1
							? 's'
							: ''}
						:
					</p>

					<ul className="inline">
						{item.Audiences.map(audience => (
							<li
								key={`audience-${audience.data.Name}`}
								className={`
									inline
									${item.Audiences.length > 1 && 'after:content-[",_"] last:after:content-[""]'}
								`}
							>
								{audience.data.Name}
							</li>
						))}
					</ul>
				</div>
			)}
			{item.End_Users && (
				<div className="text-card-product-audience mt-1.5">
					<p className="inline-block mr-1 font-bold">
						<Icon
							icon={bullseyeArrow}
							height="1rem"
							width="1rem"
							className="inline mr-1 mb-0.5 -ml-5"
						/>
						{endusersLabel}:
					</p>

					<ul className="inline">
						{item.End_Users.map(user => (
							<li
								key={`endUser-${user.data.Name}`}
								className={`
									inline
									${item.End_Users.length > 1 && 'after:content-[",_"] last:after:content-[""]'}
								`}
							>
								{user.data.Name}
							</li>
						))}
					</ul>
				</div>
			)}
		</div>
	);
};

export default ItemMeta;
